import { GraphQLError } from "graphql";

function hasRealmMismatchError(
  graphQLErrors: readonly GraphQLError[] | undefined
) {
  return (graphQLErrors || []).some((error) => {
    return (
      error.extensions?.code === 403 &&
      error.extensions?.exception?.response?.body?.reason ===
        "invalid_auth_realm"
    );
  });
}

export default hasRealmMismatchError;
